import { createSliceSelectors } from '../utils'

const CTAPromptSelectors = createSliceSelectors('ctaPrompt', ['isCTAPromptOpen', 'ctaPromptType'])

export default CTAPromptSelectors
